import React, { useEffect, useState } from "react";
import { parse } from "query-string";
import { get } from "../../../../modules/get.js";
import { toast } from "react-toastify";
import LoadingComponent from "../../../../shared/ui/animations/loading.js";
import DownloadableFileList from "../downloadableFileList/downloadableFileList.js";
import "./style.css";
import Button from "../../../../shared/ui/inputs/classicButton.js";
import { saveToZip } from "../../../c/collection/ImageGallery/ImageGallery.js";
export default function DownloadableList(props) {
    const { key, orderId } = parse(location.search);
    const [files, setFiles] = useState(null);
    const [isDownloading, setDownloading] = useState(false);
    const [downloadProgress, setDownloadProgress] = useState(0);
    useEffect(() => {
        get(`/api/public/users/order/${orderId}/orderedElectronicImages?key=${key}`).then((res) => {
            if (res.status !== 200) {
                return void toast.error("Nie udało się załadować plików");
            }
            setFiles(res.files);
        });
    }, []);
    useEffect(() => {
        if (isDownloading === false || files === null)
            return;
        saveToZip("fotografie.zip", files.map((file) => ({
            name: file.name,
            url: `/api/public/users/order/${orderId}/downloadable/${file.imageId}?key=${key}`,
        })), (curr, max) => setDownloadProgress(curr / max), () => {
            setDownloadProgress(0);
            setDownloading(false);
        });
    }, [isDownloading]);
    return (React.createElement("div", { className: "order-info-container downloadable-container" },
        React.createElement("h3", null, "Zam\u00F3wienie ma dost\u0119p do plik\u00F3w w wersji elektronicznej!"),
        React.createElement("span", null, "Poni\u017Csze pliki s\u0105 dost\u0119pne do pobrania w pe\u0142nym rozmiarze, bez znaku wodnego"),
        props.showDownloadAllButton && files !== null && (React.createElement(Button, { onClick: () => {
                setDownloading(true);
            } },
            "Pobierz wszystko (",
            files.length,
            " szt)")),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        files === null ?
            React.createElement(LoadingComponent, { color: "classic" })
            : React.createElement(React.Fragment, null,
                React.createElement(DownloadableFileList, { files: files })),
        isDownloading && (React.createElement("div", { className: "downloading-menu-container" },
            React.createElement("div", { className: "downloading-menu" },
                "Trwa przygotowywanie zdj\u0119\u0107...",
                React.createElement("br", null),
                Math.round(downloadProgress * 100),
                " %")))));
}
